export const MogiltsiData = [
    {
        title: "дом №1",
        year: '1973',
        floor: "5",
        apartment: "70",
        quantityLC: "71",
        livingArea: "3364,1",
        notLivinigArea: "нет",
        commonProperty: "273,8",
        type: "многоэтажный жилой дом",
        level: "ХВС, ГВС, отопление, канализация, газоснабжение, электроснабжение",
        technicalSupport: "общедомовой прибор учета электроэнергии",
        contractURL: 'mogiltsi/mogiltsi_1_dogovor.pdf',
        protocolURL: 'protocol_4_2017-02-16.pdf',
    }
]